<template>
  <div class="h5_home">
    <!-- 主体内容 -->
    <!-- 轮播图开始 -->
    <section class="h5_home_image">
      <van-swipe :autoplay="3000">
        <van-swipe-item v-for="(item, index) in imgList" :key="index">
          <img :src="item" alt="" class="home_img" />
        </van-swipe-item>
      </van-swipe>
    </section>
    <!-- 轮播图结束 -->
    <section class="h5_w750">
      <!-- 快捷导航开始 -->
      <div class="subnav">
        <div
          class="subnavItem"
          :class="{ m: index === 1 || index === 4 }"
          @click="otherpage(item, index)"
          v-for="(item, index) in subNavList"
          :key="index"
        >
          <img class="subnavImg" :src="item.imgUrl" alt="" />
          <p>{{ item.text }}</p>
        </div>
      </div>
      <!-- 快捷导航结束 -->
      <!-- 招生动态/就业动态开始 -->
      <div class="policy">
        <div class="home_news_left">
          <div class="home_news_left_box">
            <div
              class="home_news_title"
              @click="changeClass(item.id)"
              v-for="(item, index) in headerTitle"
              :key="index"
            >
              <div class="home_news_title_top" :class="id == index ? 'c' : ''">
                {{ item.name }}
              </div>
              <div :class="id == index ? 'active' : ''"></div>
            </div>
          </div>
          <div class="home_news_left_more" @click="toInfoOrPolicy">MORE+</div>
        </div>
        <div class="main_tzgg-item">
          <div
            class="main_tzgg"
            @click="toArticle(item)"
            v-for="item in list1"
            :key="item.id"
          >
            <div class="main_tzgg-container2">
              <div class="pc-line-l">
                <div class="pc-line-l-1">{{ item.day }}</div>
                <div class="pc-line-l-2">{{ item.year }}.{{ item.month }}</div>
              </div>
              <div ref="title" class="main_tzgg-container2-text">
                {{ item.title }}
              </div>
            </div>
            <div class="main_tzgg-container2-time">
              发布时间：{{ item.create_time }}
            </div>
          </div>
        </div>
      </div>
      <!-- 招生动态/就业动态结束 -->
      <!-- 单招/对口/统考开始 -->
      <div class="policy">
        <div class="home_news_left">
          <div class="home_news_left_box">
            <div
              class="home_news_title"
              @click="changeClass(item.id)"
              v-for="(item, index) in headerTitle1"
              :key="index"
            >
              <div class="home_news_title_top" :class="id1 == index ? 'c' : ''">
                {{ item.name }}
              </div>
              <div :class="id1 == index ? 'active1' : ''"></div>
            </div>
          </div>
          <div class="home_news_left_more" @click="toInfoOrPolicy1">MORE+</div>
        </div>
        <div class="web_news_main">
          <div class="zsxx_bottom">
            <div
              class="zsxx_content"
              @click="toArticle(item)"
              v-for="(item, index) in list2"
              :key="index"
            >
              <div class="zsxx_content_box">
                <div class="zsxx_content_yuan"></div>
                <div class="zsxx_content_text">{{ item.title }}</div>
              </div>
              <div class="zsxx_content_time">[{{ item.create_time }}]</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 单招/对口/统考开始 -->
      <!-- 就业创业开始 -->
      <div class="policy">
        <div class="home_news_left">
          <div class="home_news_left_box">
            <div class="home_news_title">
              <div class="home_news_title_top c">就业创业</div>
              <div class="active"></div>
            </div>
          </div>
          <div class="home_news_left_more" @click="$router.push('/work/jycy')">MORE+</div>
        </div>
        <div class="web_news_main">
          <div class="zsxx_bottom">
            <div
              class="zsxx_content"
              @click="toArticle(item)"
              v-for="(item, index) in list3"
              :key="index"
            >
              <div class="zsxx_content_box">
                <div class="zsxx_content_yuan"></div>
                <div class="zsxx_content_text">{{ item.title }}</div>
              </div>
              <div class="zsxx_content_time">[{{ item.create_time }}]</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 就业创业结束 -->
      <!-- 多彩校园/校园风光 -->
      <div class="policy">
        <div class="home_news_left">
          <div class="home_news_left_box">
            <div
              class="home_news_title"
              @click="changeClass(item.id)"
              v-for="(item, index) in headerTitle2"
              :key="index"
            >
              <div class="home_news_title_top" :class="id2 == index ? 'c' : ''">
                {{ item.name }}
              </div>
              <div :class="id2 == index ? 'active' : ''"></div>
            </div>
          </div>
          <div class="home_news_left_more" @click="toInfoOrPolicy2">MORE+</div>
        </div>
        <div class="w1200_bottom">
          <div class="w1200_bottom_right" v-if="id2 === 0">
            <div
              class="right_cover_box"
              v-for="(item, index) in videoList"
              :key="index"

            >
              <img class="right_cover_img" :src="item.cover_url" alt="" />
              <img class="play_img" src="@/assets/img_app/play.png" alt="" @click="toVideo(item)" />
            </div>
          </div>
          <div class="w1200_bottom_right" v-else>
            <div
              class="right_cover_box"
              v-for="(item, index) in imgList1"
              :key="index"
              @click="preview(index)"
            >
              <img class="right_cover_img" :src="item.image_url" alt="" />
            </div>
          </div>
          <div class="w1200_bottom_right">
            <div
              class="right_cover_box"
              v-for="(item, index) in imgList2"
              :key="index"
              @click="toStudents(index)"
            >
              <img class="right_cover_img" :src="item" alt="" />
            </div>
          </div>
        </div>
      </div>
      <!-- 常用链接 -->
      <div class="web_links">
        <div class="web_links_header">常用链接</div>
        <div class="web_links_list">
          <div
            class="push"
            v-for="item in linksList"
            :key="item.id"
            @click="toExternal(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import School from './School/indH5.vue'
// import Video from './School/video.vue'
// import { Swipe, SwipeItem } from 'vant';
import { ImagePreview } from 'vant'
export default {
  name: '',
  components: {},
  props: {},
  data () {
    return {
      // 招生动态
      column_id: 3,
      column_id2: 15,
      column_id3: 14,
      flag: true,
      // 招生动态
      list1: [],
      list2: [],
      list3: [],
      id: 0,
      id1: 0,
      id2: 0,
      videoList: [],
      imgList1: [],
      srcList: [],
      imgList2: [
        require('@/assets/img_app/home7.png'),
        require('@/assets/img_app/home8.png')
      ],
      imgList: [
        require('@/assets/img_app/banner1.png'),
        require('@/assets/img_app/banner2.png'),
        require('@/assets/img_app/banner3.png')
      ],
      subNavList: [
        {
          imgUrl: require('@/assets/img_app/home1.png'),
          text: '院系专业',
          path: '/zszy'
        },
        {
          imgUrl: require('@/assets/img_app/home2.png'),
          text: '招生计划',
          path: '/zsjh'
        },
        {
          imgUrl: require('@/assets/img_app/home3.png'),
          text: '历年分数',
          path: '/lnfs'
        },
        {
          imgUrl: require('@/assets/img_app/home4.png'),
          text: '招生简章',
          path: '/zsxx/dtxx'
        },
        {
          imgUrl: require('@/assets/img_app/home5.png'),
          text: '校园动态',
          path: '/xydt'
        },
        {
          imgUrl: require('@/assets/img_app/home6.png'),
          text: '奖助政策',
          path: 'jzzc'
        }
      ],
      linksList: [
        { id: 0, path: 'http://www.gxou.com.cn/', title: '广西开放大学' },
        { id: 1, path: 'http://jyt.gxzf.gov.cn/', title: '广西壮族自治区教育厅' },
        { id: 2, path: 'https://www.gxeea.cn/', title: '广西招生考试院' },
        {
          id: 3,
          path: 'https://gaokao.chsi.com.cn',
          title: '阳光高考教育平台'
        }
      ],
      headerTitle: [
        { id: 0, name: '招生动态' },
        { id: 1, name: '就业动态' }
      ],
      headerTitle1: [
        { id: 2, name: '单招' },
        { id: 3, name: '对口' },
        { id: 4, name: '统考' }
      ],
      headerTitle2: [
        { id: 5, name: '多彩校园' },
        { id: 6, name: '校园风光' }
      ]
    }
  },
  computed: {},
  watch: {},
  created () {
    this.getList1()
    this.getList2()
    this.getList3()
    this.getImage()
    this.getVideo()
  },
  mounted () {},
  methods: {
    preview (index) {
      ImagePreview({
        images: this.srcList,
        startPosition: index
      })
    },
    // 切换栏目
    changeClass (id) {
      switch (id) {
        case 0:
          this.id = 0
          this.column_id = 3
          this.getList1()
          break
        case 1:
          this.id = 1
          this.column_id = 13
          this.getList1()
          break
        case 2:
          this.id1 = 0
          this.column_id2 = 15
          this.getList2()
          break
        case 3:
          this.id1 = 1
          this.column_id2 = 16
          this.getList2()
          break
        case 4:
          this.id1 = 2
          this.column_id2 = 17
          this.getList2()
          break
        case 5:
          this.id2 = 0
          this.getList()
          break
        case 6:
          this.id2 = 1
          this.getList4()
      }
    },
    // 快捷入口跳转
    otherpage (item) {
      if (item.flag) {
        window.open(item.path)
      } else {
        this.$router.push(item.path)
      }
    },
    // 跳转文章详情页
    toArticle (item) {
      if (item.is_jump === 0) {
        this.$router.push({
          path: '/article',
          query: { id: item.id }
        })
      } else {
        window.open(item.jump_url)
      }
    },
    // 常用链接
    toExternal (item) {
      if (item.path === '') {
        alert('敬请期待...')
      } else {
        window.open(item.path)
      }
    },
    toInfoOrPolicy () {
      if (this.id === 0) this.$router.push('/zsxx/zsdt')
      else { this.$router.push('/work/jydt') }
    },
    toInfoOrPolicy1 () {
      if (this.id1 === 0) this.$router.push('/zsxx/single')
      else if (this.id1 === 1) this.$router.push('/zsxx/counterpart')
      else { this.$router.push('/zsxx/series') }
    },
    toInfoOrPolicy2 () {
      if (this.id2 === 0) this.$router.push('/campus')
      else { this.$router.push('/xyfg') }
    },
    toVideo (item) {
      this.$router.push({ path: '/campus/details', query: { url: item.video_url } })
    },
    toStudents (index) {
      if (index === 0) {
        this.$router.push('/xxjj/szll?ids=0')
      } else {
        this.$router.push('/xxjj/student?ids=0')
      }
    },
    async getList1 () {
      const { data } = await this.$get('/ow/article', {
        page: 1,
        page_size: 4,
        column_id: this.column_id
      })
      const list = data.map((item) => {
        return { ...item, ...this.$util.getDateObj(item.create_time) }
      })
      this.list1 = list
    },
    async getList2 () {
      const { data } = await this.$get('/ow/article', {
        page: 1,
        page_size: 7,
        column_id: this.column_id2
      })
      this.list2 = data
    },
    async getList3 () {
      const { data } = await this.$get('/ow/article', {
        page: 1,
        page_size: 7,
        column_id: this.column_id3
      })
      this.list3 = data
    },
    async getImage () {
      const { data, total } = await this.$get('/ow/scenery', {
        page: 1,
        page_size: 2
      })
      for (var i = 0; i < data.length; i++) {
        this.srcList.push(data[i].image_url)
      }
      this.imgList1 = data
      this.total = total
    },
    async getVideo () {
      const { data } = await this.$get('/ow/video', {
        page: 1,
        page_size: 2,
        type: 1
      })
      this.videoList = data
    },
    toPage () {
      if (this.id === 0) {
        this.$router.push('/zsxx/dzzl?ids=0')
      } else {
        this.$router.push('/yxxw?ids=0')
      }
    },
    toPage1 () {
      if (this.id1 === 0) {
        this.$router.push('/xyfg?ids=0')
      } else {
        this.$router.push('/xcsp?ids=0')
      }
    },

    changeId1 (index) {
      this.id1 = index
      this.flag = !this.flag
    },
    prev () {
      this.$refs.carousel.prev()
    },
    next () {
      this.$refs.carousel.next()
    }
  }
}
</script>

<style lang="scss" scoped>
.h5_home {
  margin-bottom: 42px;
  .h5_home_image {
    width: 100vw;
    height: 53.3333vw;
    position: relative;
    color: #fff;
    .home_img {
      width: 100%;
      height: 53.3333vw;
    }

    ::v-deep .el-carousel__indicators--horizontal {
      bottom: 10.4vw !important;
    }
    ::v-deep .el-carousel__button {
      width: 2.1333vw !important;
      height: 2.1333vw !important;
      border-radius: 50% !important;
    }
    .home_image_task {
      display: flex;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 1200px;
      height: 7.7333vw;
      justify-content: space-between;
      background: rgba(0, 0, 0, 0.5);
      text-align: center;
      line-height: 7.5333vw;
      overflow: hidden;
      cursor: pointer;
      z-index: 99;
      .common_img {
        width: 4.4vw;
        height: 7.7333vw;
      }
      .home_image_task_middle {
        width: 100%;
        // height: 7.6vw;

        ::v-deep .el-carousel {
          height: 7.7333vw !important;
          min-height: 7.7333vw !important;
        }
        ::v-deep .el-carousel__container {
          height: 7.7333vw !important;
          min-height: 7.7333vw !important;
        }
      }
    }
  }
  .h5_w750 {
    width: 100vw;
    margin: 0 auto;
    font-size: 4.2667vw;
    color: #333;
    padding: 0 4vw;
    .policy,
    .web_links {
      margin-top: 8vw;
    }
    .subnav {
      display: flex;
      flex-wrap: wrap;
      margin: 7.0667vw 6.6667vw 0;
      .subnavItem {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 18.6667vw;
        height: 24.9333vw;
        color: #333;
        margin-bottom: 4.4vw;
      }
      .m {
        margin-left: 11.3333vw;
        margin-right: 11.3333vw;
      }
      .subnavImg {
        width: 100%;
      }
    }
    .home_news_left {
      display: flex;
      justify-content: space-between;
      color: #000000;

      font-size: 4.2667vw;
      border-bottom: 1px solid #f5f4f4;
      margin-bottom: 5.3333vw;
      .home_news_left_box {
        display: flex;
      }
      .home_news_title {
        position: relative;
        width: 100%;
        margin-right: 3.7333vw;
      }
      .active,
      .active1 {
        position: absolute;
        top: 8.4vw;
        left: 3.6667vw;
        background: #4E55AF;
        width: 9.6vw;
        height: 0.8vw;
      }
      .active1 {
        left: 0;
      }
      .home_news_title_top {
        padding-bottom: 2.9333vw;
        color: #999;
      }
      .c {
        color: #000000;
      }
    }
    .pc-line-l-1 {
      width: 100%;
      height: 30px;
      background-color: #4E55AF;
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      color: #fff;
      line-height: 30px;
    }
    .pc-line-l-2 {
      background-color: #dcddef;
      font-size: 10px;
      color: #4E55AF;
      width: 100%;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .pc-line-l {
      width: 58px;
      height: 100%;
      margin-right: 10px;
    }
    .main_tzgg-container2-time {
      flex: 1;
      margin: 4.5333vw 0;
      font-size: 3.2vw;
      color: #999999;
    }
    .main_tzgg-container2-text {
      width: 76.5333vw;
      margin-left: 3.2vw;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .main_tzgg-container2 {
      margin-top: 2.1333vw;
      font-size: 4vw;
      color: #333333;
      cursor: pointer;
      box-sizing: border-box;
      display: flex;
      align-items: center;
    }
    .main_tzgg {
      border-bottom: 1px solid #f7f6f6;
    }
    .zsxx_content {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px dashed #dbdbdb;
      margin-bottom: 3.2vw;
      .zsxx_content_box {
        display: flex;

        .zsxx_content_yuan {
          width: 1.0667vw;
          height: 1.0667vw;
          background: #e88e0d;
          border-radius: 50%;
          margin-top: 2.1333vw;
          margin-right: 1.6vw;
        }
        .zsxx_content_text {
          padding-bottom: 8px;
          cursor: pointer;
          width: 62.6667vw;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .zsxx_content_time {
        color: #999999;
      }
    }
    .web_links {
      font-size: 4.8vw;
      .web_links_header {
        font-size: 4.8vw;
        color: #000000;
        margin-bottom: 2vw;
      }
      .web_links_list {
        display: flex;
        flex-wrap: wrap;
      }
      .push {
        font-size: 4vw;
        color: #1134c8;
        cursor: pointer;
        margin-right: 6.87vw;
        margin-bottom: 4.2667vw;
        text-decoration: underline;
      }
    }
    .w1200_bottom_right {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .right_cover_box {
        position: relative;
        margin-bottom: 3.7333vw;
        width: 44.5333vw;
        height: 31.2vw;
      }
      .videoItem {
        width: 100%;
        height: 50.6667vw;
      }
      .play_img {
        width: 11.4667vw;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
      }
      .right_cover_img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
</style>
